import { Redirect, Stack, useNavigation } from "expo-router"
import { View } from "react-native"
import { useLayoutEffect } from "react"
import { getFocusedRouteNameFromRoute, useRoute } from "@react-navigation/core"
import { TAB_BAR_HEIGHT } from "@/app/(tabs)/_layout"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { useStore } from "@nanostores/react"
import { $authToken } from "@/stores/auth"
import { GestureHandlerRootView } from "react-native-gesture-handler"
import { BottomSheetModalProvider } from "@gorhom/bottom-sheet"
import { BFDeskopHeader } from "@/components/standard/screen/BFDeskopHeader"
import { useIsDesktop } from "@/hooks/useIsDesktop"

const TABS_HIDDEN_ROUTES = ["ask_about_flips"]

export default () => {
  const navigation = useNavigation()
  const isDesktop = useIsDesktop()
  const route = useRoute()
  const { bottom } = useSafeAreaInsets()
  const authToken = useStore($authToken)

  useLayoutEffect(() => {
    const routeName = getFocusedRouteNameFromRoute(route) || "index"

    if (TABS_HIDDEN_ROUTES.includes(routeName)) {
      navigation.setOptions({ tabBarStyle: { display: "none" } })
    } else {
      navigation.setOptions({
        tabBarStyle: { display: "flex", height: TAB_BAR_HEIGHT + bottom },
      })
    }
  }, [navigation, route])

  if (!authToken) {
    return <Redirect href="/register" />
  }

  return (
    <GestureHandlerRootView
      className="flex-1 web:flex web:flex-col web:max-h-dvh"
      style={{ flex: 1 }}
    >
      <BottomSheetModalProvider>
        {isDesktop && <BFDeskopHeader />}
        <View className="max-w-[650px] self-center w-full flex-1">
          <Stack>
            <Stack.Screen
              name="index"
              options={{
                headerShown: false,
                title: "Account",
                // EN-4877
                // animation: "slide_from_bottom",
                // presentation: "modal",
              }}
            />
            <Stack.Screen
              name="personal-info/index"
              options={{ headerShown: false, title: "Personal Info" }}
            />
            <Stack.Screen
              name="personal-info/name"
              options={{ headerShown: false, title: "" }}
            />
            <Stack.Screen
              name="personal-info/email"
              options={{ headerShown: false, title: "" }}
            />
            <Stack.Screen
              name="personal-info/phone"
              options={{ headerShown: false, title: "" }}
            />
            <Stack.Screen
              name="myleads"
              options={{ headerShown: false, title: "" }}
            />
            <Stack.Screen
              name="notifications"
              options={{ headerShown: false, title: "" }}
            />
            <Stack.Screen
              name="debug"
              options={{ headerShown: false, title: "Debug" }}
            />
            <Stack.Screen
              name="qualification"
              options={{ headerShown: false, title: "Qualifications" }}
            />
            <Stack.Screen
              name="ask_about_flips"
              options={{
                headerShown: false,
                animation: "slide_from_bottom",
                presentation: "modal",
              }}
            />
          </Stack>
        </View>
      </BottomSheetModalProvider>
    </GestureHandlerRootView>
  )
}
